import { trackAnalytics } from 'services/analytics';

export const faOnServicesClick = ({ name }) => {
  trackAnalytics({
    eVar9: `b2b|selfcare|side nav|services|${name.toLowerCase()}`,
  })
};

export const faOnNeedHelpClick = () => {
  trackAnalytics({
    eVar9: `b2b|selfcare|side nav|need help`,
  })
};
